// extracted by mini-css-extract-plugin
export var container = "styles-module--container--95b9a";
export var wide = "styles-module--wide--8e948";